import authRules from '../authRules';

const viewStatus = (user) => {
  const { status } = user.securityLevels;
  if (status >= authRules.viewStatus.status) {
      return true;
  } else {
      return false;
    }
  }


export default viewStatus;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/viewStatus.js